/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * VDPService.Channel state.
 *
 * @enum {Integer}
 * @readonly
 */
export enum CHANNEL_STATE {
   CLOSED = 0, // Channel has been closed.
   CLOSING = 1, // Channel has been requested to close.
   OPEN = 2, // Channel open.
   NOT_READY = 3, // Channel accepted but a Channel Object is PENDING.
   READY = 4 // Channel is ready to send RPCs.
}
